import { useEffect } from 'react';
import { useRouter } from 'next/router';

const ScrollToTop = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      // Only scroll if the pathname has changed (ignoring query parameters)
      const newPathname = url.split('?')[0];
      const currentPathname = router.pathname;
      
      if (newPathname !== currentPathname) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, router.pathname]);

  return null;
};

export default ScrollToTop; 
